import type { StudentHistoryDates } from '@mathflat/domain/StudentHistory'
import type { DateStr } from 'src/types/common/commonTypes'

import { DTO } from '../DTO'

type HistoryDate = StudentHistoryDates['recentDate']

type ConstructorParams = {
  beforeDate: HistoryDate
  currentDate: HistoryDate
  afterDate: HistoryDate
}

// 이전, 오늘, 이후 날짜
export class BeforeAfterDay extends DTO {
  beforeDate?: DateStr<'-'>
  currentDate?: DateStr<'-'>
  afterDate?: DateStr<'-'>

  constructor(d: Partial<ConstructorParams>) {
    super()
    // 서버 LocalDate 는 yyyy-MM-dd 로 오고 스키마가 경계에서 검증한다
    this.beforeDate = (d.beforeDate ?? undefined) as DateStr<'-'> | undefined
    this.currentDate = (d.currentDate ?? undefined) as DateStr<'-'> | undefined
    this.afterDate = (d.afterDate ?? undefined) as DateStr<'-'> | undefined
  }

  get currentRealDate() {
    if (this.currentDate) {
      return new Date(this.currentDate)
    }
  }

  get isEmpty() {
    return !this.beforeDate && !this.currentDate && !this.afterDate
  }
}
